<template>
	<div :class="classNames+ '_subwrap'">
		<!-- 账号授权信息 -->
		<authAccount :authInfo="authInfo" :authCode="authCode"></authAccount>
		<div :class="classNames+ '_main'" v-if="authInfo.step == 3 && authInfo.surplus_time > 0">
			<div :class="classNames+ '_sidebar'">
				<ul :class="classNames+ '_chatlist'" v-infinite-scroll="getChatMember">
					<li v-for="(item,index) of chatListData.data" :key="item.user_openid" :title="item.user_info.nick_name" :class="[
						classNames+ '_chatlist_chat chat-s-contact',chatIdIndex == item.user_openid ? 'chat-s-contact--active': ''
					]" @click.prevent.stop="getChatWindow(item)">
						<span class="chat-s-badge chat-s-contact__avatar">
							<span class="chat-s-avatar">
								<img :src="item.user_info.avatar"  v-if="item.user_info.avatar"  :alt="item.user_info.nick_name" style="width: 40px;height:40px;">
							</span>
							<span class="chat-s-badge__label" v-show="item.is_red_dot == 1"></span>
						</span>
						<div class="chat-s-contact__inner">
							<p class="chat-s-contact__label">
								<span class="chat-s-contact__name">{{item.user_info.nick_name}}</span>
								<span class="chat-s-contact__time">{{item.msgtime_desc}}</span>
							</p>
							<p class="chat-s-contact__content"><span>{{item.latest_msg}}</span></p>
						</div>
					</li>
					
				</ul>
				<div :class="classNames+ '_chatlist_no'" v-if="chatListData.data.length == 0">
					暂无用户
				</div>
			</div>
			<template v-if="chatIdIndex">
				<div :class="classNames+ '_content chat-container'">
					<div class="chat-s-container__title"><span>{{chatIdUser.user_info.nick_name}}</span></div>
					<div class="chat-s-vessel">
						<div class="chat-s-vessel__left">
							<div class="chat-s-messages" :data-id="item.id+','+item.chat.user_openid"  v-for="item of chatUserMsgInfoData" :key="item.id+'_'+item.chat.user_openid" v-if="chatIdIndex == item.user_openid" ref="messagesWindow">
								<div class="chat-s-message chat-s-message--status-succeed chat-s-message--hide-title chat-s-message-text" v-for="(chatItem,index) of item.data" :class="chatItem.message_info.from_user_id == chatItem.user_openid ? '': 'chat-s-message--reverse'">
								       
										 <template v-if="chatItem.message_info.content.user_infos[0].open_id != chatItem.message_info.content.user_infos[1].open_id"  >
											 <div class="chat-s-message__avatar"  v-for="(userInfo,uidx) of chatItem.message_info.content.user_infos" :key="userInfo.open_id">
											 	
											 	<span class="chat-s-avatar chat-s-avatar--circle" shape="square" v-if="chatItem.message_info.from_user_id == userInfo.open_id"
											         style="width: 36px; height: 36px; line-height: 36px; font-size: 18px;">
											 		<img   style="width: 36px; height: 36px; line-height: 36px; font-size: 18px;"
											             :src="userInfo.avatar">
											 			
											 		</span>
											 			
											 </div>
											 
										 </template>
										 <template v-else>
											 <div class="chat-s-message__avatar">
												<span class="chat-s-avatar chat-s-avatar--circle" shape="square"
													 style="width: 36px; height: 36px; line-height: 36px; font-size: 18px;">
													<img   style="width: 36px; height: 36px; line-height: 36px; font-size: 18px;"
														 :src="chatItem.message_info.content.user_infos[0].avatar">
														
													</span>
														
											 </div>
										 											 
										 </template>
										
										
										
								        <div class="chat-s-message__inner">
								            <div class="chat-s-message__title"></div>
								            <div class="chat-s-message__content-flex">
								                <div class="chat-s-message__content"><span>
													<messageText :data="chatItem.message_info.content" v-if="chatItem.message_info.content.message_type == 'text'"></messageText>
													<messageImage :data="chatItem.message_info.content" v-else-if="chatItem.message_info.content.message_type == 'image'"></messageImage>
												<messageEmoji :data="chatItem.message_info.content" v-else-if="chatItem.message_info.content.message_type == 'emoji'"></messageEmoji>
													<messageVideo :data="chatItem.message_info.content" v-else-if="chatItem.message_info.content.message_type == 'video'"></messageVideo>
													<messageCard :data="chatItem.message_info.content" v-else-if="chatItem.message_info.content.message_type == 'card'"></messageCard>
													<messageRetain :data="chatItem.message_info.content" v-else-if="chatItem.message_info.content.message_type == 'retain_consult_card'"></messageRetain>
													<messageOther :data="chatItem.message_info.content" v-else-if="chatItem.message_info.content.message_type == 'other'"></messageOther>
													<messageOther :data="chatItem.message_info.content" v-else></messageOther>
												</span></div>
								                <div class="chat-s-message__content-after"></div>
								                <div class="chat-s-message__status"><i class="chat-s-icon-loading lemonani-spin"></i><i title="重发消息"
								                        class="chat-s-icon-prompt" style="color: rgb(255, 37, 37); cursor: pointer;"></i></div>
								            </div>
								        </div>
								    </div>
								
							</div>
							    <div class="chat-s-editor">
							        <div class="chat-s-editor__tool">
							            <div class="chat-s-editor__tool-left">
											<span class="chat-s-editor__emoji" style="position: relative;">
												<emoFaceCard  v-model="toolEmoFaceModal" @emoFace="emoFace"></emoFaceCard>
							                    <div title="表情" class="chat-s-editor__tool-item" @click="toolEmoFaceFun()">
													<img src="http://img-dbzd.doubaozhidao.com/20230516/1684242378536513.png" alt="表情">	
													<span>表情</span>
												</div>
							                </span>
							                <div title="快捷回复" class="chat-s-editor__tool-item" @click="toolFastReplyFun()">
												<img src="http://img-dbzd.doubaozhidao.com/20230516/1684242220074476.png" alt="">
												<span>快捷回复</span>
											</div>
							                <div title="卡片" class="chat-s-editor__tool-item" @click="toolCardFun()">
												<img src="http://img-dbzd.doubaozhidao.com/20230516/1684242353402582.png" alt="">
												<span>卡片</span>
											</div>
											
							            </div>
							        </div>
							        <div class="chat-s-editor__inner">
							            <div 
											contenteditable="true" 
											spellcheck="false" 
											class="chat-s-editor__input" 
											ref="editChat"
											@keydown="_handleKeydown"
											@paste='_handlePaste'
											@input="changeChatContent">
										</div>
							        </div>
							        <div class="chat-s-editor__footer">
							            <div class="chat-s-editor__tip"><strong :class="chatMsgLen > 150 ? 'font-tip' : ''">{{chatMsgLen}}</strong>/150</div>
							            <div class="chat-s-editor__submit"><button  type="button" :disabled="chatMsgLen <= 0"
							                    class="chat-s-button chat-s-button--color-default"  @click="sendMessageChat">发 送</button></div>
							        </div>
							    </div>
							
						</div>
						<div class="chat-s-vessel__right">
							<fastReplyCard v-model="toolFastReplyCard" @sendInfo="sendInfo"></fastReplyCard>
							<markerCard  v-model="toolMarkerCard" @sendCardInfo="sendCardInfo"></markerCard>
						</div>
					</div>
				</div>
			</template>
			<template v-else>
				<div :class="classNames+ '_content chat-nobody'">
					<div class="chat-no_logo">
						<p class="desc"><img src="@/assets/image/logo-231019.png" alt="" />豆包知道</p>
						<p class="desc">有内容来变现,有课程来变现;有技能来变现,好用的短视频内容变现工具!</p>
					</div>
				</div>
			</template>
		</div>
		
	</div>
</template>
<script>

import authAccount from './auth-account.vue'
import useTable from '@/components/useTable/useTable.vue'
import emoFaceCard from './components/tools/emoFaceCard.vue'
import fastReplyCard from './components/tools/fastReplyCard.vue'
import markerCard from './components/tools/markerCard.vue'
import messageText from './components/message/message-text.vue'
import messageCard from './components/message/message-card.vue'
import messageImage from './components/message/message-image.vue'
import messageEmoji from './components/message/message-emoji.vue'
import messageVideo from './components/message/message-video.vue'
import messageRetain from './components/message/message-retain.vue'
import messageOther from './components/message/message-other.vue'
import { mapActions } from 'vuex'

export default {
	data() {
		return {
			classNames: 'chatList',
			chatIndex: -1,
			chatIdIndex: '',
			chatIdUser: {},
			chatListData: {
				total: 0,
				data: []
			},
			searchObj: {
				limit: 4,
				page: 1,
				status: 1,
				loading: false
			},
			chatUserMsgInfoData: [],
			sendChatInfo: {
				id: '',
				to_user_id: '',
			    msg_id: '',
			    conversation_id: '',
			    send_message: '',
			    msg_type: 1
			},
			clipboardUrl: '',
			clipboardBlob: null,
			toolEmoFaceModal: false,
			toolFastReplyCard: false,
			toolMarkerCard: false,
			intervalChatMember: null,
			intervalChatMsg: null,
			authInfo: {
				account_info: {
					avatar: '',
					nickname: ''
				},
				step: 1,
			},
			authCode: {
				code: '',
				state: ''
			}
		}
	},
	computed: {
		chatMsgLen () {
			return this.sendChatInfo.send_message.length
		}
	},
	components: {
		authAccount,
		emoFaceCard,
		markerCard,
		fastReplyCard,
		messageText,
		messageCard,
		messageImage,
		messageEmoji,
		messageVideo,
		messageRetain,
		messageOther
	},
	created() {
		this.getDouyinBindInfo()
		if(this.$route.query && this.$route.query.code){
			this.authCode = this.$route.query
		}
	},
	beforeDestroy() {
	    if(this.intervalChatMember){
	    	clearInterval(this.intervalChatMember)
	    }
		if(this.intervalChatMsg){
			clearInterval(this.intervalChatMsg)
		}
	},
	methods: {
		...mapActions('dymessage', ['chatMember','chatMsginfo','chatSendMessage','chatMsgRead','dyBindInfo']),
		async getDouyinBindInfo(){
			const res = await this.dyBindInfo()
			if(res){
				this.authInfo = res
				if(res.step == 3) {
					this.initChat()
				}
			} else {
				this.$message({
					type: 'error',
					duration: 3000,
					message: '授权失败，请重试'
				})
			}
		},
		async getChatMember(loopStatus = false) {
			if(this.searchObj.loading) {
				return 
			}
			const params = {}
			let res = {}
			if(loopStatus){
				params.page = 1
				params.limit = this.searchObj.limit
				this.searchObj.loading = true
				res = await this.chatMember(params)
				this.searchObj.loading = false
			} else {
				params.page = this.searchObj.page
				params.limit = this.searchObj.limit
				this.searchObj.loading = true
				res = await this.chatMember(params)
				if(res.list.length < this.searchObj.limit) {
					this.searchObj.loading = true
				}else {
					this.searchObj.page++
					this.searchObj.loading = false
				}
			}
			this.initChatData(res)
		},
		getChatWindow(data) {
			this.chatIdIndex = data.user_openid
			this.chatIdUser = data
			let chatIndex = this.chatUserMsgInfoData.findIndex((item)=> item.user_openid == data.user_openid)
			if(chatIndex < 0){
				const userChatData = {
					id: data.user_openid,
					user_openid: data.user_openid,
					search:{
						limit: 20,
						page: 1
					},
					chat: data,
					total: 0,
					data: []
				}
				this.chatUserMsgInfoData.push(userChatData)
			}
			chatIndex = this.chatUserMsgInfoData.findIndex((item) => item.user_openid == data.user_openid)
			this.chatIndex = chatIndex
			this.initChatMsgData()
		},
		changeChatContent(event){
			this.setUserSendMsg(false)
		},
	
		 async sendMessageChat() {
			if(this.chatMsgLen <= 0 || this.chatMsgLen > 150){
				return
			}
			const chatInfo  = this.chatUserMsgInfoData.filter((item)=> item.user_openid == this.chatIdIndex)
			if(!chatInfo.length){
				return 
			}
			const chatInfoSingle = chatInfo[0].data.filter((item)=> item.author_openid != item.message_info.from_user_id)
			const params = {
				id: this.sendChatInfo.id,
				to_user_id: chatInfoSingle[chatInfoSingle.length - 1].user_openid,
				msg_id: chatInfoSingle[chatInfoSingle.length - 1].message_info.content.server_message_id,
				conversation_id: chatInfoSingle[chatInfoSingle.length - 1].message_info.content.conversation_short_id,
				send_message: this.sendChatInfo.send_message,
				msg_type: this.sendChatInfo.msg_type
			}
			this.sendChatInfo.id = ''
			let res = await this.chatSendMessage(params)
			if(res == '发送成功'){
				this.initConstructorMsg(params,chatInfoSingle)
				this.clearChatMsg()
				this.chatScrollTop()
			}
		},
		clearChatMsg(){
			this.$refs.editChat.innerHTML = '';
			this.sendChatInfo =  {
				id: '',
				to_user_id: '',
			    msg_id: '',
			    conversation_id: '',
			    send_message: '',
			    msg_type: 1
			}
		},
		toolEmoFaceFun(){
			this.toolEmoFaceModal = !this.toolEmoFaceModal
		},
		toolFastReplyFun(){
			this.toolFastReplyCard = !this.toolFastReplyCard
		},
		toolCardFun(){
			this.toolMarkerCard = !this.toolMarkerCard
		},
		_handlePaste(e) {
		  e.preventDefault();
		  let text;
		  let clp = (e.originalEvent || e).clipboardData;
		  if (clp === undefined || clp === null) {
			text = window.clipboardData.getData("text") || "";
			if (text !== "") {
			  if (window.getSelection) {
				this.setSendChatInfo(text)
			  } else {
				this.setSendChatInfo(text)
			  }
			}
		  } else {
			text = clp.getData('text/plain') || "";
			if (text !== "") {
			  this.setSendChatInfo(text)
			}
		  }
		},
		_handleKeydown(e){
			if(e.keyCode == 13 && e.ctrlKey === true){
				this.sendMessageChat()
			} else if(e.keyCode == 13 && e.meta === true){
				this.sendMessageChat()
			}
		},
		emoFace(data){
			this.$refs.editChat.innerHTML += data;
			this.setUserSendMsg()
		},
		sendInfo(data){
			this.sendChatInfo.id = data.id
			if(data.type == 1){
				this.$refs.editChat.innerHTML += data.content 
			} else {
				this.$refs.editChat.innerHTML += data.link_url
			}
			this.setUserSendMsg()
		},
		sendCardInfo(data){
			if(data.card_type  == 3){
				this.sendChatInfo.send_message = data.open_card_id
				this.sendChatInfo.msg_type = 8
				this.sendMessageChat()
			} else {
				this.sendChatInfo.send_message = data.open_card_id
				this.sendChatInfo.msg_type = 4
				this.sendMessageChat()
			}
			
		},
		setSendChatInfo(data){
			this.$refs.editChat.innerHTML += data
			this.setUserSendMsg()
		},
		setUserSendMsg(status = true){
			const sendMessage = this.clearHtml(this.$refs.editChat.innerHTML.trim())
			// this.$refs.editChat.innerHTML = sendMessage
			this.sendChatInfo.send_message = sendMessage
			// if(status){
				  const chatDom = this.$refs.editChat
				  if (window.getSelection) {
					const range = window.getSelection()
					range.selectAllChildren(chatDom)
					range.collapseToEnd();
				  }
			// }
		},
		async setUserReadStatus(data){
			const ids = data.map((item,idx)=>{
				if(item.read_status == 1) {
					return item.id
				}else {
					return ''
				}
			})
			const filterIds = ids.filter((item) => {
			    return (item != '' )
			})
			if(filterIds.length){
				await this.chatMsgRead({id: filterIds})
				this.chatUserMsgInfoData[this.chatIndex].read_status = 2
				// console.log(this.chatUserMsgInfoData[this.chatIndex],'this.chatUserMsgInfoData[this.chatIndex]')
				// const read_status = this.chatUserMsgInfoData[this.chatIndex]
				// read_status.read_status = 2
				// this.$set(this.chatUserMsgInfoData, this.chatIndex, read_status])
			}
		},
		initChat(){
			this.intervalChatMember = setInterval(() =>{
				this.getChatMember(true)
				this.searchObj.loading = false
			},1000 * 6)
			this.intervalChatMsg = setInterval(() =>{
				this.initChatMsgData()
			},1000 * 5)
		},
		initChatData(res){
			const data  = [...this.chatListData.data,...res.list]
			let chatList = this.chatUnique(data, 'user_openid') 
			this.chatListData = {total:res.count,data: [...chatList]}
		},
		async initChatMsgData(){
			const chatIndex = this.chatIndex
			if(chatIndex <0 ) {
				return
			}
			const chatParams = this.chatUserMsgInfoData[chatIndex]
			const params = Object.assign({},chatParams.search)
			params.user_openid = chatParams.chat.user_openid
			params.author_openid = chatParams.chat.author_openid
			const resData = await this.chatMsginfo(params)
			this.chatUserMsgInfoData[chatIndex].total = resData.count
			this.chatUserMsgInfoData[chatIndex].data = resData.list.reverse()
			this.chatScrollTop()
			this.setUserReadStatus(resData.list)
		},
		initConstructorMsg(sendUser,lastMsg){
			const chatIndex = this.chatIndex
			const oldMsgList = this.chatUserMsgInfoData[chatIndex].data
			const lastUserMsg = lastMsg[lastMsg.length -1]
			
			if(sendUser.msg_type == 4){
				sendUser.send_message = '您发送了一条消息卡片，PC不支持查看！'
			} else if(sendUser.msg_type == 8){
				sendUser.send_message = '您发送了一条留资卡片，PC不支持查看！'
			}
			const times = Date.now()
			let userMsg = 
			{
			  "id": times,
			  "event": "im_send_msg",
			  "user_openid": sendUser.to_user_id,
			  "author_openid": lastUserMsg.author_openid,
			  "message_type": "text",
			  "server_message_id": sendUser.msg_id,
			  "conversation_type": 1,
			  "latest_msg": sendUser.send_message,
			  "msgtime": times,
			  "read_status": 2,
			  "message_info": {
			    "event": "im_send_msg",
			    "content": {
			      "text": sendUser.send_message,
			      "scene_type": 100,
			      "user_infos": lastUserMsg.message_info.content.user_infos,
			      "create_time": times,
			      "message_type": "text",
			      "conversation_type": 1,
			      "server_message_id": sendUser.msg_id,
			      "conversation_short_id": sendUser.conversation_id
			    },
			    "to_user_id": sendUser.to_user_id,
			    "from_user_id": lastUserMsg.author_openid,
			  }
			}
			oldMsgList.push(userMsg)
			this.$set(this.chatUserMsgInfoData, chatIndex, this.chatUserMsgInfoData[chatIndex])
		},
		chatUnique(arr, name) {
			let hash = {}
			return arr.reduce( (acc, cru, index) => {
				if ( !hash[cru[name]] ) {
					hash[cru[name]] = {index:acc.length} 
					acc.push(cru)
				}else{
					acc.splice( hash[cru[name]]['index'], 1, cru)
				}
				return acc;
			}, [])
		},
		chatScrollTop(){
			this.$nextTick(() => {
				const messagesWindow = this.$refs.messagesWindow[0]
				messagesWindow.scrollTop = messagesWindow.scrollHeight
			})
		},
		clearHtml(str){
		  return str.replace(/<.*?>/ig,"");
		}
	}
}
</script>
<style lang="less" scoped>
	 @classNames: chatList;
	 .@{classNames}_main{
		display: flex;
		flex: 1;
		height: 800px;
	 }
	 .chatItemClass{
		padding: 10px 14px;
		cursor: pointer;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		overflow: hidden;
		background: #efefef;
		text-align: left
	 }
	 .@{classNames}_sidebar{
	 	width: 200px;
		background-color:#fff;
		border: 1px solid #d7d7d7;
		box-sizing: border-box;
		margin-right: 10px;
		max-height: 800px;
		background: #efefef;
		.@{classNames}_chatlist{
			max-height: 100%;
			overflow: auto;
			.@{classNames}_chatlist_item{
				cursor: pointer;
				&:extend(.chatItemClass);
				&:hover{
				 background: #f5f7fa;
				 .group_icon{
				 	display: block;
				 }
				}
				&.active{
					background-color: #409eff!important;
					color: #FFFFFF!important;
					.group_icon{
						display: block;
					}
				}
				.chat_title{
					width: 120px;
					overflow: hidden;
					text-overflow: ellipsis; 
					-o-text-overflow: ellipsis;
					white-space:nowrap;
				}
			}
		}
	 }
	 .@{classNames}_chatlist_no{
			line-height: 20px;
			text-align: center;
			padding: 10px 0;
			font-size: 16px;
			color: #666;
		}
	 .@{classNames}_content{
		 display: flex;
		 flex-direction: column;
		 flex: 1;
	 }
	 .font-tip{
		font-weight: normal;
		 color: red;
	 }
</style>
<style src="./css/dy-chat.css" scoped></style>
<style lang="less" scoped>
		.chat-no_logo {
			background: #FFF;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			img {
				margin-right: 8px;
				width: 26px;
				border-radius: 100%;
			}
			.desc {
				margin-top: 20px;
				font-size: 14px;
				color: #7f7f7f;
				display: flex;
			}
		}
	
	.chat-s-container__title {
	    background-color: #d7d7d7 !important;
	}
	.chat-s-badge .chat-s-badge__label {
	       padding: 0 4px;
	       height: 10px;
	       line-height: 17px;
	       width: 2px;
		   min-width: 2px;
	}
	.chat-s-messages{
		background-color: #f2f2f2;
	}
	.chat-s-vessel__left {
	    margin-top: 10px;
	}
</style>

